namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_viewport_frame, {
		
		// pointerEvents: 'none',
		Widget_head: {
			pointerEvents: 'auto',
			margin: {
				top: '-40px',
			},
		},
		
		Top_edge: { pointerEvents: 'auto' },
		Left_edge: { pointerEvents: 'auto' },
		Bottom_edge: { pointerEvents: 'auto' },
		Right_edge: { pointerEvents: 'auto' },
		Top_left_edge: { pointerEvents: 'auto' },
		Top_right_edge: { pointerEvents: 'auto' },
		Bottom_left_edge: { pointerEvents: 'auto' },
		Bottom_right_edge: { pointerEvents: 'auto' },
		Left_top_edge_ratio: { pointerEvents: 'auto' },
		Left_bottom_edge_ratio: { pointerEvents: 'auto' },
		Right_bottom_edge_ratio: { pointerEvents: 'auto' },
		Right_top_edge_ratio: { pointerEvents: 'auto' },
		Top_left_edge_ratio: { pointerEvents: 'auto' },
		Top_right_edge_ratio: { pointerEvents: 'auto' },
		Bottom_left_edge_ratio: { pointerEvents: 'auto' },
		Bottom_right_edge_ratio: { pointerEvents: 'auto' },

		// '[shm_hitalama_map_widget_float_selected]': {
		// 	true: {
		// 		Widget_head: {
		// 			outline: '1px solid var(--mol_theme_current)',
		// 			":hover": {
		// 				outline: '1px solid var(--mol_theme_current)',
		// 			},
		// 		},
		// 	},
		// },
		// '[shm_hitalama_map_widget_float_dragged]': {
		// 	true: {
		// 		Widget_head: {
		// 			outline: '1px solid var(--mol_theme_control)',
		// 			":hover": {
		// 				outline: '1px solid var(--mol_theme_control)',
		// 			},
		// 		},
		// 	},
		// },

		Num: {
			pointerEvents: 'auto',
			position: 'absolute',
			top: 0,
			right: 0,
			transformOrigin: 'top right',
			transition: 'none',
		},

	} )
	
}
